var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playback-area"},[_c('div',{staticClass:"aisea-text-16-400-black"},[_vm._v("指定範囲: "+_vm._s(_vm.specifyAreaText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }